var map = {
	"./calendar.svg": [
		7775,
		775
	],
	"./check.svg": [
		1343,
		343
	],
	"./chevron-down.svg": [
		5830,
		830
	],
	"./chevron-left.svg": [
		4724,
		724
	],
	"./chevron-right.svg": [
		5714,
		714
	],
	"./copy.svg": [
		3460,
		460
	],
	"./cross.svg": [
		7769,
		769
	],
	"./edit.svg": [
		3584,
		584
	],
	"./email.svg": [
		1062,
		62
	],
	"./gift.svg": [
		5584,
		76
	],
	"./hide.svg": [
		2006,
		6
	],
	"./home.svg": [
		636,
		757
	],
	"./info.svg": [
		7698,
		698
	],
	"./invoice.svg": [
		5616,
		616
	],
	"./list.svg": [
		5228,
		228
	],
	"./logo.svg": [
		9832,
		832
	],
	"./minus.svg": [
		1950,
		950
	],
	"./phone.svg": [
		5881,
		881
	],
	"./plus.svg": [
		4536,
		536
	],
	"./save.svg": [
		6678,
		678
	],
	"./search.svg": [
		7477,
		477
	],
	"./settings.svg": [
		9891,
		891
	],
	"./share.svg": [
		7637,
		637
	],
	"./speaker.svg": [
		6530,
		530
	],
	"./stripe.svg": [
		9422,
		422
	],
	"./ticket.svg": [
		4588,
		588
	],
	"./user.svg": [
		2605,
		605
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 5367;
module.exports = webpackAsyncContext;